$(document).ready(function () {
	$(document).on('change', '[data-cart="product"] .product-price-toggler', function () {
		let price_id = $(this).val(),
			$item = $(this).closest('[data-cart=product]');

		$item.find('.prices-comments .comment').removeClass('active');
		$item.find('.comment[data-price_id="' + price_id + '"]').addClass('active');

		return false;
	});
});
